const hotelInfoTypes = {
  FETCHING: "HOTEL_INFO_FETCHING",
  DETAILS: "HOTEL_DETAILS",
  SELECT_ROOM: "SELECT_ROOM",
  DESELECT_ROOM: "DESELECT_ROOM",
  SELECT_ADDON: "SELECT_ADDON",
  DESELECT_ADDON: "DESELECT_ADDON",
  TOTAL_PEOPLE: "TOTAL_PEOPLE",
  TOTAL_ADULT: "TOTAL_ADULT",
  TOTAL_CHILD: "TOTAL_CHILD",
  SET_DATE: "SET_DATE",
  DATE_COUNT: "DATE_COUNT",
  RESET: "RESET",
  SELECT_RP: "SELECTED_RP",
  EDIT_RP: "EDIT_RP",
  DESELECT_RP: "DESELECT_RP",
  RESET_RP: "RESET_RP",
  SET_COUPON_CODE: "SET_COUPON_CODE",
  ADD_REVIEW: "ADD_REVIEW",
  SET_UPDATED_ROOM_COUNT: "SET_UPDATED_ROOM_COUNT",
  ADD_RATING: "ADD_RATING",
  ADD_HOTELADDON: "ADD_HOTELADDON",
  REMOVE_HOTELADDON: "REMOVE_HOTELADDON",
  PENDING_REASONS: "PENDING_REASONS",
  SET_INSTA_LINKS: "SET_INSTA_LINKS",
  SET_PROMOTION: "SET_PROMOTION",
  GET_FAQ: "GET_FAQ",
  GET_POLICY: "GET_POLICY",
  SET_PAYMENTS: "SET_PAYMENTS",
  FETCH_REVIEW: "FETCH_REVIEW",
  FETCH_REVIEW_Arjun: "FETCH_REVIEW_Arjun",
  SHOW_HOURLY: "SHOW_HOURLY",
  SET_HOURLY_DATE: "SET_HOURLY_DATE",
  SET_SHOW_HOURLY: "SET_SHOW_HOURLY",
  SET_HOURLY_TIME: "SET_HOURLY_TIME",
  SET_SLOTS: "SET_SLOTS",
  SET_HOUR: "SET_HOUR",
  RESET_ROOM: "RESET_ROOM",
  SET_ROOM: "SET_ROOM",
  SET_IS_RATEPLAN: "SET_IS_RATEPLAN",
  SET_LIVE_PRICE: "SET_LIVE_PRICE",
  SET_TAXES: "SET_TAXES",
  SET_OWNER_DETAILS: "SET_OWNER_DETAILS",
  EMPTY_ROOM: "EMPTY_ROOM",
  SET_PAYMENT_PROVIDER: "SET_PAYMENT_PROVIDER",
  BNPL_CONFIG: "BNPL_CONFIG",
  GET_SCRIPT_TAG_ID: "GET_SCRIPT_TAG_ID",
  REMOVE_RP: "REMOVE_RP",
  UPDATE_RP: "UPDATE_RP",
  DESET_ROOM: "DESET_ROOM",
  SET_RETARGETING: "SET_RETARGETING",
  SET_NOTIFY_NO_INVENTORY: "SET_NOTIFY_NO_INVENTORY",
  TOTAL_INFANT: "TOTAL_INFANT",
  CALENDAR_PRICE_DISPLAY: "CALENDAR_PRICE_DISPLAY",
  SET_HOTELVIDEOS: "SET_HOTELVIDEOS",
  SET_SIGN_UP: "SET_SIGN_UP",
  SET_FULL_STATE: "SET_FULL_STATE",
  SET_CONTINUE_BOOKING: "SET_CONTINUE_BOOKING",
  SET_UPSELL: "SET_UPSELL",
  SHOW_MEMBERSHIP_MODAL: "SHOW_MEMBERSHIP_MODAL",
  SET_STERLING_MEMBER_SUCCESS: "SET_STERLING_MEMBER_SUCCESS",
  RESET_SELECTED_RATEPLANS: "RESET_SELECTED_RATEPLANS",
  SET_BOOKING_ENGINE_CONFIG: "SET_BOOKING_ENGINE_CONFIG",
  SET_BOOKING_ENGINE_CONFIG_LOADING: "SET_BOOKING_ENGINE_CONFIG_LOADING",
  SET_NEARBY_HOTELS: "SET_NEARBY_HOTELS",
  SET_RETURNING_MEMBER: "SET_RETURNING_MEMBER",
  SET_PAYMENT_METHOD_OFFER: "SET_PAYMENT_METHOD_OFFER",
  SET_PAYMENT_METHOD_PROMOTIONS: "SET_PAYMENT_METHOD_PROMOTIONS",
  SET_MAHARAJA_ID: "SET_MAHARAJA_ID",
  SET_MAHARAJA_ID_ERROR: "SET_MAHARAJA_ID_ERROR",
  SET_GSTIN: "SET_GSTIN",
};

export default hotelInfoTypes;
